import cn from 'classnames'
import { Form, Field } from 'react-final-form'
import { ArrowCta } from '@mc/certificates-design-system'
import { InputField, CheckboxField } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { TrackClick } from 'pages/certificates/tracking'
import { validateEmailWithGdpr } from 'pages/certificates/validations'
import classes from './DownloadSyllabus.module.scss'

export const DownloadSyllabusForm = ({
  onSubmit,
}: {
  onSubmit: (values: { email: string }) => void
}) => {
  const { t } = useTranslation('@mc/certificates')

  return (
    <Form
      validate={validateEmailWithGdpr}
      initialValues={{ gdprOptIn: false }}
      onSubmit={onSubmit}
      render={({ handleSubmit, hasValidationErrors }) => (
        <form className='d-flex flex-column flex-gap-2' onSubmit={handleSubmit}>
          <div className='d-flex flex-column flex-sm-row flex-gap-2 flex-fill align-items-top'>
            <Field
              render={({ input, meta, ...restProps }) => {
                const metaWithoutErrors = {
                  ...meta,
                  error: undefined,
                  submitError: undefined,
                  invalid: false,
                }
                return (
                  <InputField
                    {...restProps}
                    input={input}
                    meta={metaWithoutErrors}
                    label={t('downloadSyllabus.emailAddress')}
                    className='flex-grow-1 mc-w-100'
                  />
                )
              }}
              name='email'
              id='email'
              type='email'
              placeholder={t('emailPlaceholder')}
              autoComplete='email'
              required
              className={`${classes.input} mc-w-100`}
            />
            <TrackClick event='syllabusModalClicked'>
              <ArrowCta
                className={cn(classes.button, 'align-self-start')}
                type='submit'
                disabled={hasValidationErrors}
                style={{ marginTop: '18px' }}
              >
                {t('marketingPages.common.signUp')}
              </ArrowCta>
            </TrackClick>
          </div>
          <Field
            render={({ input, meta, ...restProps }) => {
              const metaWithoutErrors = {
                ...meta,
                error: undefined,
                submitError: undefined,
                invalid: false,
              }
              return (
                <CheckboxField
                  {...restProps}
                  input={input}
                  meta={metaWithoutErrors}
                  className='mc-text-x-small mc-text-color--tint mc-mt-2'
                />
              )
            }}
            name='gdprOptIn'
            label={t('marketingPages.certificate.updatesSignup.gdpr')}
            required
          />
        </form>
      )}
    />
  )
}
